var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { registerLocaleData } from '@angular/common';
import { getRouteConfig } from '@app/core/models/routeConfig';
import localeNL from '@angular/common/locales/nl';
import { AppConfigService } from '@app/core/services/app-config-service';
registerLocaleData(localeNL);
export const initializeApp = (appConfig) => () => __awaiter(this, void 0, void 0, function* () { return appConfig.loadSettings(); });
const ɵ0 = getRouteConfig();
export class AppModule {
}
export { ɵ0 };
